export async function getImages() {
  const res = await fetch("/par/php-backend");
  const data = await res.json();

  return data;
}

/** GET FIVE IMAGES FROM ALL IMAGE ARRAY */
export function imgArr(imgArr, i, size) {

  if(typeof i == "string") {
    i = parseInt(i);
  }

  let newImgArr = Object.values(imgArr).slice(i, i + parseInt(size));

  return newImgArr;
}

/** TAKE THE FIVE IMAGE ARRAY AND PARSE IT TO A FULLY FORMATTED DATE */
export function parseImgsToFullDate(img) {

    img.substring(img.length-6, img.length);
    
    const year = img.substring(0, 4);
    const month = img.substring(4, 6);
    const day = img.substring(6, 8);
    const hour = img.substring(9, 11);
    const min = img.substring(11, 13);
    const sec = img.substring(13, 15);

    const date = `${year}-${month}-${day}T${hour}:${min}:${sec}`;
    const formattedDate = new Date(date);
    
    return formattedDate;
}

/** PARSE FIVE IMAGE ARRAY TO A STANDARD DATE */
export function parseImgToDate(img) {
  
  const year = img.substring(0, 4);
  const month = img.substring(4, 6);
  const day = img.substring(6, 8);

  const date = `${month}/${day}/${year}`;
  
  return date;

}

/** PARSE FIVE IMAGE ARRAY TO JUST THE TIME */
export function parseImgsToTime(img) {

  img.substring(img.length-6, img.length);
  
  const hour = img.substring(9, 11);
  const min = img.substring(11, 13);
  const sec = img.substring(13, 15);

  const time = `${hour}:${min}:${sec}`;
  
  return time;
}

export function getImagesByType(images, type) {
  let newImgArr = [];

  images.forEach(
    img => {
      //console.log(img.substring(img.length, img.length - 6));
      if(type === "qc" && img.substring(img.length, img.length - 6) === "qc.png") {
        newImgArr.push(img);
      } else if(type === "dr" && img.substring(img.length, img.length - 6) === "dr.png") {
        newImgArr.push(img);
      }
    }
  );

  return newImgArr;
  
}